import React from "react";

const TablePagination = ({
    currentPage,
    totalPages,
    pageSize,
    handlePageChange,
    handlePageSize,
}) => {

    const getVisiblePages = () => {

        const pages = [];

        let startPage = Math.max(
            currentPage - 2,
            1
        );

        let endPage = Math.min(
            startPage + 4,
            totalPages
        );

        // adjust start again
        startPage = Math.max(
            endPage - 4,
            1
        );

        for (
            let i = startPage;
            i <= endPage;
            i++
        ) {

            pages.push(i);

        }

        return pages;

    };

    return (

        <div
            className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 px-3 py-3 bg-white rounded-4 border shadow-sm"
        >

            {/* LEFT */}
            <div className="d-flex align-items-center gap-2">

                <span className="small fw-semibold text-secondary">
                    Rows Per Page
                </span>

                <div className="position-relative">

                    <select
                        className="form-select shadow-none border-0 pe-5"
                        style={{
                            width: "90px",
                            height: "38px",
                            borderRadius: "12px",
                            background: "#f8fafc",
                            fontSize: "14px",
                            fontWeight: "600",
                            cursor: "pointer",
                            appearance: "none",
                        }}
                        value={pageSize}
                        onChange={(e) =>
                            handlePageSize(
                                Number(e.target.value)
                            )
                        }
                    >

                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>

                    </select>

                    <i
                        className="fa fa-chevron-down position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
                        style={{
                            pointerEvents: "none",
                            fontSize: "12px",
                        }}
                    ></i>

                </div>

            </div>

            {/* CENTER */}
            <div className="small text-muted fw-semibold">

                Page{" "}
                <span className="text-primary">
                    {currentPage}
                </span>{" "}
                of{" "}
                <span className="text-dark">
                    {totalPages || 1}
                </span>

            </div>

            {/* RIGHT */}
            <div className="d-flex align-items-center gap-2 flex-wrap">

                {/* FIRST */}
                <button
                    className="btn btn-light border shadow-sm"
                    disabled={currentPage === 1}
                    onClick={() =>
                        handlePageChange(1)
                    }
                    style={{
                        borderRadius: "12px",
                        height: "38px",
                    }}
                >
                    First
                </button>

                {/* PREVIOUS */}
                <button
                    className="btn btn-light border shadow-sm d-flex align-items-center justify-content-center"
                    disabled={currentPage === 1}
                    onClick={() =>
                        handlePageChange(
                            currentPage - 1
                        )
                    }
                    style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "12px",
                    }}
                >

                    <i className="fa fa-chevron-left small"></i>

                </button>

                {/* PAGE NUMBERS */}
                <div className="d-flex align-items-center gap-2 flex-wrap">

                    {getVisiblePages().map(
                        (page) => (

                            <button
                                key={page}
                                onClick={() =>
                                    handlePageChange(
                                        page
                                    )
                                }
                                className={`btn btn-sm fw-semibold ${
                                    currentPage === page
                                        ? "btn-primary text-white"
                                        : "btn-light border"
                                }`}
                                style={{
                                    minWidth:
                                        "38px",
                                    height:
                                        "38px",
                                    borderRadius:
                                        "12px",
                                }}
                            >

                                {page}

                            </button>

                        )
                    )}

                </div>

                {/* NEXT */}
                <button
                    className="btn btn-light border shadow-sm d-flex align-items-center justify-content-center"
                    disabled={
                        currentPage ===
                        totalPages
                    }
                    onClick={() =>
                        handlePageChange(
                            currentPage + 1
                        )
                    }
                    style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "12px",
                    }}
                >

                    <i className="fa fa-chevron-right small"></i>

                </button>

                {/* LAST */}
                <button
                    className="btn btn-light border shadow-sm"
                    disabled={
                        currentPage ===
                        totalPages
                    }
                    onClick={() =>
                        handlePageChange(
                            totalPages
                        )
                    }
                    style={{
                        borderRadius: "12px",
                        height: "38px",
                    }}
                >
                    Last
                </button>

            </div>

        </div>

    );

};

export default TablePagination;